// Pembantu Edge Function drive-proxy (Google Drive via Supabase).
// Semua akses fail (bukti bayaran & PDF resit) melalui endpoint terautentikasi ini.
import { supabase, supabaseUrl } from './supabaseClient';

const fnBase = () => {
  const url = (supabaseUrl || '').replace(/\/$/, '');
  return `${url}/functions/v1/drive-proxy`;
};

async function authHeaders() {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.access_token) throw new Error('Sesi tamat. Sila log masuk semula.');
  return { Authorization: `Bearer ${session.access_token}` };
}

const MAX_BYTES = 5 * 1024 * 1024;
const OK_MIME = ['image/jpeg', 'image/png', 'image/webp', 'application/pdf'];

export function validateProofFile(file) {
  if (!file) return 'Sila pilih fail.';
  if (file.size > MAX_BYTES) return 'Saiz fail melebihi 5MB.';
  if (!OK_MIME.includes(file.type)) return 'Hanya gambar (JPG/PNG/WebP) atau PDF dibenarkan.';
  return null;
}

/** Upload bukti bayaran (orangtua). invoiceIds: array untuk bayar beberapa bulan sekaligus. */
export async function uploadBukti({ file, studentId, invoiceId, invoiceIds }) {
  const err = validateProofFile(file);
  if (err) throw new Error(err);
  const headers = await authHeaders();
  const form = new FormData();
  form.append('file', file, file.name);
  form.append('jenis', 'bukti');
  form.append('student_id', studentId);
  const ids = (invoiceIds && invoiceIds.length ? invoiceIds : (invoiceId ? [invoiceId] : []));
  if (ids.length === 1) form.append('invoice_id', ids[0]);
  if (ids.length > 0) form.append('invoice_ids', JSON.stringify(ids));
  const res = await fetch(`${fnBase()}/upload`, { method: 'POST', headers, body: form });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || !json.ok) throw new Error(json.error || `Muat naik gagal (${res.status}).`);
  return json;
}

/** Upload PDF resit (bendahara, selepas pengesahan). Mengembalikan { drive_file_id }. */
export async function uploadResitPdf({ blob, receiptId, filename }) {
  const headers = await authHeaders();
  const form = new FormData();
  form.append('file', blob, filename || `resit-${Date.now()}.pdf`);
  form.append('jenis', 'resit');
  if (receiptId) form.append('receipt_id', receiptId);
  const res = await fetch(`${fnBase()}/upload`, { method: 'POST', headers, body: form });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || !json.ok) throw new Error(json.error || `Muat naik resit gagal (${res.status}).`);
  return json;
}

/** Muat fail dari Drive sebagai object URL (untuk pratonton / unduh). */
export async function driveObjectUrl(driveFileId) {
  const headers = await authHeaders();
  const res = await fetch(`${fnBase()}/file?id=${encodeURIComponent(driveFileId)}`, { headers });
  if (!res.ok) {
    const j = await res.json().catch(() => ({}));
    throw new Error(j.error || `Gagal memuat fail (${res.status}).`);
  }
  const blob = await res.blob();
  return { url: URL.createObjectURL(blob), mime: blob.type || 'application/octet-stream', blob };
}

export function revokeObjectUrl(u) {
  try { if (u) URL.revokeObjectURL(u); } catch { /* abaikan */ }
}
